export const Experience = {
  VMGEN: 'VMGEN',
  DigitalWindow: 'DigitalWindow',
}
